import(/* webpackMode: "eager" */ "/runner/_work/mx-platform/mx-platform/cdn/de-sxm-www/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["StickyCtaBfcacheSync"] */ "/runner/_work/mx-platform/mx-platform/cdn/de-sxm-www/src/components-2.0/contentful/StickyCta/StickyCtaBfcacheSync.tsx");
;
import(/* webpackMode: "eager" */ "/runner/_work/mx-platform/mx-platform/cdn/de-sxm-www/src/styles/global-styles.scss");
